import { CONTENT_TYPE_RISK_PROFILE_QUESTION } from '../../../../../prebuilt/content-types/amtc-questions/constant';
import AbstractStructuredContentController from '../../../abstract/structured-content/controller';

class Controller extends AbstractStructuredContentController {
    constructor(widget) {
        super(widget, CONTENT_TYPE_RISK_PROFILE_QUESTION);
        this.init(widget);
    }
    init(widget) {
        const widgetContext = $(widget.htmlNode);
        const screenName = "RISKPROFILEQUESTIONS";
        var currentRadioContext = $("input[type=radio]", widgetContext);
        var currentId = currentRadioContext.attr("id");
        var currentContainer = $("#" + currentId).closest(".question-container");
        var questionContainerCount = $(".widget-single-question-cont", currentContainer).length;

        var currentMainSection = $(".widget-single-question-cont", widgetContext).closest("div[id^=step-]");
        var currentSubContainer = $(".widget-single-question-cont", widgetContext).closest("div[id^=sub-step-]");
        var currentStep = currentMainSection.attr("id");
        var currentSubStep = currentSubContainer.attr("id");

        var questionData = {
            step: currentStep,
            questionCount: questionContainerCount,
            currentChoice: currentId,
            currentContainer: currentContainer,
            currentValue: 0,
            currentQuestion: "",
            numberOfChecked: 0
        }
        var screenData = {
            name: screenName,
            values: {
                container: "#" + currentStep + ">.bp-area>#" + currentSubStep,
                fieldValue: questionData
            }
        };
        var summaryData = {
            currentChoice: currentId,

        }
        $(".screenContinue", widgetContext).click(() => {
            this.getAnswers(currentId,currentContainer,questionData,screenData,summaryData,widgetContext);
        });

        currentRadioContext.click(() => {
            this.getAnswers(currentId,currentContainer,questionData,screenData,summaryData,widgetContext);

        });
    }
    getAnswers(currentId,currentContainer,questionData,screenData,summaryData,widgetContext){
        var currentValue = $("#" + currentId + ":checked").val();
        var numberOfChecked = $("input[type='radio']:checked", currentContainer).length;
        questionData.currentValue = currentValue;
        questionData.currentQuestionAns = $("#" + currentId + ":checked", widgetContext).next().text();
        questionData.currentQuestion = $(".widget-single-question-cont .widget-single-question-item", widgetContext).text();
        questionData.numberOfChecked = numberOfChecked;
        questionData.indexOfSelected =$('input[id='+currentId+']',currentContainer).index($('input[id='+currentId+']',currentContainer).filter(':checked'));
        screenData.values.fieldValue = questionData;
        App.PubSub.publish("digitalApplicationForm", screenData);



        summaryData.answerText = $("#" + currentId + ":checked", widgetContext).next().text();
        summaryData.question = $(".widget-single-question-cont .widget-single-question-item", widgetContext).text();
        summaryData.answer = currentValue;
        App.PubSub.publish("SummaryData", summaryData);
    }

}


export default Controller;



// WEBPACK FOOTER //
// ./collection-institutional-portal/src/widgets/widget-risk-profiler-questions/widget-single-question/scripts/controller.js